function createSubscription() {
    // placeholder
}

export default createSubscription;
